module.exports = __webpack_public_path__ + "img/2.baa6a2f9.jpg";